import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IHospitalServiceLocation } from 'app/models/licenses/hospital/hospital-service-location';

@Injectable({providedIn: 'root'})
export class HospitalServiceLocationService {

  private api: string = environment.privateApi + 'HospitalServiceLocation/';
  private http: HttpClient = inject(HttpClient);

  public getHospitalServiceLocations(entityId: number, entityType: string, includeArchived: boolean): Observable<IHospitalServiceLocation[]>{
    return this.http.get<IHospitalServiceLocation[]>(this.api + 'GetHospitalServiceLocations/' + entityId + '/' + entityType + '/' + includeArchived);
  }

  public createHospitalServiceLocation(hospitalServiceLocation: IHospitalServiceLocation, entityId: number, entityType: string): Observable<IHospitalServiceLocation>{
    return this.http.post<IHospitalServiceLocation>(this.api + 'CreateHospitalServiceLocation/' + entityId + '/' + entityType, hospitalServiceLocation);
  }

  public updateHospitalServiceLocation(hospitalServiceLocation: IHospitalServiceLocation): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'UpdateHospitalServiceLocation', hospitalServiceLocation);
  }

  public saveDraft(location: IHospitalServiceLocation): Observable<IHospitalServiceLocation> {
    return this.http.post<IHospitalServiceLocation>(this.api + 'SaveDraft', location);
  }

  public archiveHospitalServiceLocation(hospitalServiceLocationId: number, archive: boolean): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'ArchiveHospitalServiceLocation/' + hospitalServiceLocationId + '/' + archive, null);
  }

  public deleteHospitalServiceLocation(hospitalServiceLocationId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'DeleteHospitalServiceLocation/' + hospitalServiceLocationId);
  }
}
